export const mutations = {
  setEntityDetails(state, entityDetails) {
    state.entityDetails = entityDetails;
  },
  resetEntityDetails(state) {
    state.entityDetails = null;
  },
};
